<app-navbar></app-navbar>
<div class="error-page">
  <div class="error-card">
    <div class="error-code">403</div>
    <h1 class="error-title">Access Denied</h1>
    <p class="error-message">
      You don't have permission to view this content.
      Please contact your administrator if you believe this is an error.
    </p>
    <a routerLink="/" class="error-btn">Return to Home</a>
  </div>
</div>
